import React from "react";

export default function InteresadosSummary({ resumen, onQuickFilter, activeKey }) {
  const cards = [
    { key: "total", label: "Interesados", value: resumen.total ?? 0, icon: "bi bi-people-fill", accent: "total" },
    {
      key: "pendientes_coordinacion",
      label: "Transferidos sin matricular",
      value: resumen.pendientes_coordinacion ?? 0,
      icon: "bi bi-person-up",
      accent: "primary",
    },
    { key: "nuevo", label: "Nuevos", value: resumen.nuevo ?? 0, icon: "bi bi-stars", accent: "info" },
    /* {
      key: "interesado",
      label: "En seguimiento",
      value: resumen.interesado ?? 0,
      icon: "bi bi-chat-dots",
      accent: "primary",
    }, */
    {
      key: "prematriculado",
      label: "Pre-matriculados",
      value: resumen.prematriculado ?? 0,
      icon: "bi bi-journal-check",
      accent: "warning",
    },
    {
      key: "matriculado",
      label: "Matriculados",
      value: resumen.matriculado ?? 0,
      icon: "bi bi-mortarboard",
      accent: "success",
    },
    {
      key: "descartado",
      label: "Descartados",
      value: resumen.descartado ?? 0,
      icon: "bi bi-slash-circle",
      accent: "danger",
    },
  ];

  return (
    <div className="management-card int-summary-card mb-4">
      <div className="int-summary-grid">
        {cards.map((card) => (
          <button
            key={card.key}
            type="button"
            className={`management-stat-card int-card ${card.accent} ${activeKey === card.key ? "active" : ""}`}
            onClick={() => onQuickFilter?.(card.key)}
          >
            <div className="management-stat-icon">
              <i className={card.icon} />
            </div>
            <div>
              <p className="management-stat-label mb-1">{card.label}</p>
              <p className="management-stat-value mb-0">{card.value}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
